import styled from "styled-components";

export const ContainterRemainingTime = styled.div`
	display: flex;
	font-weight: bold;
	font-size: 14px;
`;
export const ContainterItemRemainingTime = styled.div`
	margin-left: 5px;
`;
export const ConfirmTitle = styled.span`
	display: block;
	margin-bottom: 0.5rem;
`;
export const ConfirmText = styled.span`
	display: block;
	font-weight: normal;
`;
